export default __webpack_public_path__ + "static/media/section0-bg3.4257f94d.png";